import { NgModule } from '@angular/core';

import { OpenIdSsoModule } from './modules/open-id-sso/open-id-sso.module';
import { SamlSsoModule } from './modules/saml-sso/saml-sso.module';

@NgModule({
    imports: [
        OpenIdSsoModule,
        SamlSsoModule
    ],
    exports: [],
    declarations: [],
    providers: [],
})
export class SSOModule { }
